import { useCallback, useState } from "react";

import { getPrivateSubModule, getPublicModule, getPublicSubModule } from "../Services/APIs/LandingPage";

export const useFetchModuleData = (setModuleInfo, setAllSubModuleInfo, subVarientIdGlobal, setLandingPageSection, setAlert) => {
  const [isLoading, setIsLoading] = useState(true);

  // Helper function to get module keys
  const getModuleKeys = useCallback((data) => {
    try {
      const baseModuleKeys = Object.keys(data || {});
      return baseModuleKeys;
    } catch (error) {
      console.error('Error getting module keys:', error);
      return [];
    }
  }, []);

  // Fetch public module data
  const fetchPublicSubModuleData = useCallback(async () => {
    try {
      setIsLoading(true);
      const result = await getPublicSubModule();
      if (result?.status === 200) {
        setLandingPageSection(result?.data?.landing_page_sections);
        const newSubModule = result?.data?.modules;
        const moduleKeys = getModuleKeys(newSubModule);
        setAllSubModuleInfo(newSubModule);
        setModuleInfo(Array.isArray(moduleKeys) ? moduleKeys : []);
        return newSubModule;
      }
    } catch (error) {
      console.error('Error fetching public modules:', error);
      setAlert({ show: true, message: error?.data?.error || "unable to get Module info", type: 'error' });
    } finally {
      setIsLoading(false);
    }
  }, [getModuleKeys, setModuleInfo]);

  // Fetch private module data
  const fetchPrivateSubModuleData = useCallback(async (id) => {
    try {
      if (!subVarientIdGlobal) {
        console.warn('Cannot fetch private modules: subVarientIdGlobal is not set');
        return;
      }
      setIsLoading(true);
      const params = `card_id=${id || subVarientIdGlobal}`;
      const result = await getPrivateSubModule(params);
      if (result?.status === 200) {
        const newSubModule = result?.data;
        setAllSubModuleInfo(newSubModule);
        const moduleKeys = getModuleKeys(newSubModule);
        setModuleInfo(Array.isArray(moduleKeys) ? moduleKeys : []);
        return newSubModule;
      }
    } catch (error) {
      console.error('Error fetching private modules:', error);
      setAlert({ show: true, message: error?.data?.error || "unable to get Module info", type: 'error' });
    } finally {
      setIsLoading(false);
    }
  }, [getModuleKeys, setModuleInfo, subVarientIdGlobal, setAllSubModuleInfo]);

  const fetchPublicModuleData = useCallback(async (id) => {
    try {
      setIsLoading(true);
      const params = `card_id=${id}`;
      const result = await getPublicModule(params);
      if (result?.status === 200) {
        const newSubModule = result?.data;
        setAllSubModuleInfo(newSubModule);
        const moduleKeys = getModuleKeys(newSubModule);
        setModuleInfo(Array.isArray(moduleKeys) ? moduleKeys : []);
        return newSubModule;
      }
    } catch (error) {
      console.error('Error fetching private modules:', error);
      setAlert({ show: true, message: error?.data?.error || "unable to get Module info", type: 'error' });
    } finally {
      setIsLoading(false);
    }
  }, [getModuleKeys, setModuleInfo, subVarientIdGlobal, setAllSubModuleInfo]);

  return { fetchPublicSubModuleData, fetchPrivateSubModuleData, fetchPublicModuleData, isLoading };
};